import { __extends } from '../../../../node_modules/tslib/tslib.es6.js';
import { utils, Contract, ContractFactory } from 'ethers';

var _abi = [{
  inputs: [],
  stateMutability: "nonpayable",
  type: "constructor"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "stakingContract",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "newOwner",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "previousOwner",
    type: "address"
  }],
  name: "NewStakingContractOwner",
  type: "event"
}, {
  inputs: [{
    internalType: "address",
    name: "_stakingContract",
    type: "address"
  }, {
    internalType: "address",
    name: "_owner",
    type: "address"
  }, {
    internalType: "address",
    name: "_previousOwner",
    type: "address"
  }],
  name: "assignOwnerToContract",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  name: "authorisedCallers",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "_owner",
    type: "address"
  }],
  name: "contractCountPerOwner",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  name: "contractIndex",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  name: "contractToOwner",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "controller",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address[]",
    name: "_array",
    type: "address[]"
  }, {
    internalType: "address",
    name: "value",
    type: "address"
  }],
  name: "getIndexArray",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }, {
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "pure",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }, {
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  name: "ownerToContracts",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "_caller",
    type: "address"
  }, {
    internalType: "bool",
    name: "_value",
    type: "bool"
  }],
  name: "setCaller",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "_newController",
    type: "address"
  }],
  name: "setController",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}];
var _bytecode = "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";
var isSuperArgs = function (xs) {
  return xs.length > 1;
};
var StakingRegistry__factory = /** @class */function (_super) {
  __extends(StakingRegistry__factory, _super);
  function StakingRegistry__factory() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    var _this = this;
    if (isSuperArgs(args)) {
      _this = _super.apply(this, args) || this;
    } else {
      _this = _super.call(this, _abi, _bytecode, args[0]) || this;
    }
    return _this;
  }
  StakingRegistry__factory.prototype.deploy = function (overrides) {
    return _super.prototype.deploy.call(this, overrides || {});
  };
  StakingRegistry__factory.prototype.getDeployTransaction = function (overrides) {
    return _super.prototype.getDeployTransaction.call(this, overrides || {});
  };
  StakingRegistry__factory.prototype.attach = function (address) {
    return _super.prototype.attach.call(this, address);
  };
  StakingRegistry__factory.prototype.connect = function (signer) {
    return _super.prototype.connect.call(this, signer);
  };
  StakingRegistry__factory.createInterface = function () {
    return new utils.Interface(_abi);
  };
  StakingRegistry__factory.connect = function (address, signerOrProvider) {
    return new Contract(address, _abi, signerOrProvider);
  };
  StakingRegistry__factory.bytecode = _bytecode;
  StakingRegistry__factory.abi = _abi;
  return StakingRegistry__factory;
}(ContractFactory);

export { StakingRegistry__factory };
